import React, { useCallback, useState } from "react";
import { Button } from "reactstrap";
import apiGd from "services/apiGd";
import { Form } from "@unform/web";
import Select from "views/components/Form/SelectInput";
import { endOfDay, startOfMonth } from "date-fns";
import { FullHourCalendar, InformationDiv } from "ui-kit-takeat";

export default function OrderControl({ notify, restaurant_id }) {
  const token = localStorage.getItem("@QRExpress:tokenGd");

  const [updateType, setUpdateType] = useState('cancel');
  const [filterDateStart, setFilterDateStart] = useState(startOfMonth(new Date()));
  const [filterDateEnd, setFilterDateEnd] = useState(endOfDay(new Date()));
  const channelOptions = [
    { label: 'iFood', value: 'IFOOD' },
    { label: 'Takeat', value: 'TAKEAT' },
    { label: 'Keeta', value: 'KEETA' },
    { label: '99', value: '99FOOD' },
    { label: 'Neemo', value: 'NEEMO' },
    { label: 'Cardápio Web', value: 'CARDAPIOWEB' },
  ];
  const [selectChannels, setSelectChannels] = useState(channelOptions.map((us) => us.value));

  const handleUpdate = useCallback(async () => {
    if (window.confirm('Tem certeza que deseja atualizar esses pedidos nesse intervalo de tempo?')) {
      try {
        await apiGd.put(`admin/restaurants/ifood/orders/${restaurant_id}`, null, {
          params: {
            start_date: filterDateStart,
            end_date: filterDateEnd,
            type: updateType,
            channels: selectChannels,
          },
          headers: { Authorization: `Bearer ${token}` }
        },
        );

        notify('tr', 'success', 'Pedidos atualizados');
      } catch (err) {
        console.log(err);
        notify('tr', 'danger', err?.response?.data?.message || 'Erro ao atualizar pedidos');
      }
    }
  }, [token, filterDateEnd, filterDateStart, updateType, selectChannels]);

  const optionSelect = [
    { label: 'Cancelar', value: 'cancel' },
    { label: 'Finalizar', value: 'finish' }
  ];

  return (
    <>
      <Form>
        <InformationDiv
          text={<>
            Selecione o período para atualizar os pedidos <b>delivery não agendados</b> do painel do Delivery <br />
            Ao <b>cancelar</b> os pedidos serão cancelados e os pagamentos serão deletados e removidos de seus respectivos caixas <br />
            Ao <b>finalizar</b> os pedidos serão finalizados sem emitir nota fiscal <br />
            <b>Os status não serão atualizados nas integrações</b>
          </>}
          type='info'
        />
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', float: 'right' }}>
          <FullHourCalendar
            value={{ start: filterDateStart, end: filterDateEnd }}
            onDateSelected={(e) => {
              setFilterDateStart(e.start);
            }}
          />
          <FullHourCalendar
            isEnd
            value={{ start: filterDateStart, end: filterDateEnd }}
            onDateSelected={(e) => {
              setFilterDateEnd(e.end);
            }}
          />
          <div style={{ minWidth: '200px' }}>
            <Select
              name="type"
              options={optionSelect}
              defaultValue={optionSelect.find(op => op.value === updateType)}
              onChange={e => setUpdateType(e.value)}
            />
          </div>
          <div style={{ minWidth: '200px' }}>
            <Select
              name="channels"
              options={channelOptions}
              defaultValue={channelOptions}
              isMulti
              onChange={(e) =>
                setSelectChannels(
                  e && e.length > 0 ? e.map((us) => us.value) : []
                )
              }
            />

          </div>
          <div>
            <Button
              type="button"
              onClick={handleUpdate}
              style={{ float: "right", backgroundColor: "#2ec9b7", borderRadius: 8 }}
            >
              Confirmar
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
}
